import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { NavigationActionTiming, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { ToastrModule } from 'ngx-toastr';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { metaReducers, reducers } from './app.reducer';
import { AuthEffects } from './auth/state/auth.effects';
import { CustomControlsModule } from './custom-controls/custom-controls.module'; // to be resolved
import { ErrorComponent } from './error/error.component';
import { getErrorHandler } from './error/getErrorHandler.factory';
import { AuthInterceptor } from './interceptors/auth.interceptors';
import { ErrorInterceptor } from './interceptors/error.interceptors';
import { LayoutModule } from './layout/layout.module'; // to be resolved
import { RouterFacade } from './router/router.facade';
import { RouterEffects } from './router/state/router.effects';
import { CustomRouterSerializer } from './router/state/router.reducer';
import { LocationsService } from './services/locations.service';
import { SharedModule } from './shared/shared.module'; // to be resolved
import { UpdateServiceWorkerService } from './services/update-sw.service';
import { Insomnia } from '@awesome-cordova-plugins/insomnia/ngx';
import { Drivers, Storage } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';

@NgModule({
  declarations: [AppComponent, ErrorComponent],
  imports: [ BrowserModule,
    IonicModule.forRoot(),
    BrowserAnimationsModule,
    FormsModule,
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    }),
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictStateSerializability: false,
        strictActionSerializability: false,
      },
    }),
    EffectsModule.forRoot([AuthEffects, RouterEffects]),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router',
      serializer: CustomRouterSerializer,
      navigationActionTiming: NavigationActionTiming.PreActivation,
    }),
    CustomControlsModule,
    ...environment.imports,
    LayoutModule,
    IonicStorageModule.forRoot({
        name: '__naistrodb',
        driverOrder: [Drivers.IndexedDB]
    })
  ],
  providers: [
    LocationsService,
    RouterFacade,
    UpdateServiceWorkerService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    Insomnia
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
